import styles from '../ProfileDeatailForInternalExternal/InviteTalentModal/EmailPreviewTemplate.module.css';
import {
  FiArrowLeft,
  FiDownload,
  FiTrash2,
  FiMail,
  FiMoreVertical,
  FiStar,
  FiCornerUpLeft,
  FiChevronDown,
} from 'react-icons/fi';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import { ReactComponent as SkillGigs } from '../../assets/img/SkillGigs_tm-black 4.svg';
import { ReactComponent as AppStoreBadge } from '../../assets/img/app-store-badge.svg';
import { ReactComponent as GooglePlayBadge } from '../../assets/img/google-play-badge.svg';

const SUMMARY_ICONS = {
  'Title':      'https://skillgigs-v3-stag-documents-cl.s3.us-east-2.amazonaws.com/content/templates-assets/Vector.png',
  'Job Type':   'https://skillgigs-v3-stag-documents-cl.s3.us-east-2.amazonaws.com/content/templates-assets/Vector (1).png',
  'Start Date': 'https://skillgigs-v3-stag-documents-cl.s3.us-east-2.amazonaws.com/content/templates-assets/Vector (2).png',
  'Location':   'https://skillgigs-v3-stag-documents-cl.s3.us-east-2.amazonaws.com/content/templates-assets/Vector (3).png',
  'Skills':     'https://skillgigs-v3-stag-documents-cl.s3.us-east-2.amazonaws.com/content/templates-assets/Vector (4).png',
};

const buildJobSummary = (selectedJob) => {
  if (!selectedJob) return [];
  return [
    { label: 'Title', value: selectedJob.title },
    { label: 'Job Type', value: selectedJob.type },
    { label: 'Start Date', value: selectedJob.startDate },
    { label: 'Location', value: selectedJob.location },
    ...(selectedJob.skillsList?.length
      ? [{ label: 'Skills', chips: selectedJob.skillsList }]
      : []),
  ].filter((d) => d.value || d.chips?.length);
};

const renderJobSummary = (details) => {
  if (!details.length) return <span>Job Detail</span>;
  return (
    <div className={styles.jobSummaryList}>
      {details.map((detail) => (
        <div key={detail.label} className={styles.jobSummaryItem}>
          <div className={styles.jobSummaryItemHeader}>
            {SUMMARY_ICONS[detail.label] && (
              <img
                src={SUMMARY_ICONS[detail.label]}
                alt=""
                className={styles.jobSummaryIcon}
              />
            )}
            <span className={styles.jobSummaryItemLabel}>{detail.label}</span>
          </div>
          {detail.chips ? (
            <div className={styles.skillChipsRow}>
              {detail.chips.map((chip) => (
                <span key={chip} className={styles.skillChip}>{chip}</span>
              ))}
            </div>
          ) : (
            <span className={styles.jobSummaryItemValue}>{detail.value}</span>
          )}
        </div>
      ))}
    </div>
  );
};

const buildTemplateConfig = (co, jt) => ({
  'Template 1': {
    subject: `Reminder: Your invitation from ${co} is waiting`,
    intro: `Your invitation for ${jt} is still waiting.`,
    buttonText: 'View Invitation',
  },
  'Template 2': {
    subject: `${co} is still waiting to hear from you`,
    intro: 'The employer is still interested in your profile.',
    buttonText: 'Accept Invitation',
  },
  'Template 3': {
    subject: 'Final reminder: Your invitation may expire soon',
    intro: 'This opportunity may close soon.',
    buttonText: 'Accept Invitation',
  },
});

const ReminderEmailPreviewTemplate = ({ talentFirstName, jobTitle, selectedJob, message, companyName, selectedTemplate = 'Template 1' }) => {
  const jt = jobTitle || 'Job Title';
  const co = companyName || 'Company Name';
  const TEMPLATE_CONFIG = buildTemplateConfig(co, jt);
  const config = TEMPLATE_CONFIG[selectedTemplate] || TEMPLATE_CONFIG['Template 1'];
  const subject = config.subject;
  const intro = config.intro;
  const displayedJobDetails = buildJobSummary(selectedJob);

  return (
    <div className={styles.container}>
      {/* Top navigation bar */}
      <div className={styles.topNav}>
        <FiArrowLeft className={styles.navIcon} />
        <div className={styles.navIcons}>
          <FiDownload className={styles.navIcon} />
          <FiTrash2 className={styles.navIcon} />
          <FiMail className={styles.navIcon} />
          <FiMoreVertical className={styles.navIcon} />
        </div>
      </div>

      {/* Email subject line */}
      <div className={styles.subjectRow}>
        <div className={styles.subjectContent}>
          <span className={styles.subjectText}>{subject}</span>
          <span className={styles.inboxBadge}>Inbox</span>
        </div>
        <FiStar className={styles.starIcon} />
      </div>

      {/* Sender information */}
      <div className={styles.senderRow}>
        <div className={styles.senderAvatar}>SG</div>
        <div className={styles.senderInfo}>
          <div>
            <span className={styles.senderName}>Skillgigs</span>
            <span className={styles.senderTime}>Yesterday</span>
          </div>
          <div className={styles.toMe}>
            to me <FiChevronDown size={14} />
          </div>
        </div>
        <div className={styles.senderActions}>
          <FiCornerUpLeft className={styles.actionIcon} />
          <FiMoreVertical className={styles.actionIcon} />
        </div>
      </div>

      {/* Email body */}
      <div className={styles.emailBody}>
        <div className={styles.sgLogoContainer}>
          <SkillGigs />
        </div>

        <p className={styles.emailPara}>
          Hi {talentFirstName || 'Candidate First Name'},
        </p>

        <p className={styles.emailPara}>{intro}</p>

        <>
          <p className={styles.sectionLabel}>Message from the Hiring Team</p>
          <div className={styles.messageBox}>
            &ldquo;{message || 'Employer Custom Message'}&rdquo;
          </div>
          <p className={styles.sectionLabel}>Job Details</p>
          {renderJobSummary(displayedJobDetails)}
        </>

        <a
          href="https://skillgigs.com"
          className={styles.bidButton}
          target="_blank"
          rel="noreferrer"
        >
          {config.buttonText}
        </a>

        <p className={styles.emailPara}>
          Never Miss a Job Opportunity. Download Now on{' '}
          <a href="https://apps.apple.com/app/skillgigs/id1476711597" className={styles.contactLink} target="_blank" rel="noreferrer">iOS</a> or{' '}
          <a href="https://play.google.com/store/apps/details?id=com.skillgigs" className={styles.contactLink} target="_blank" rel="noreferrer">Android</a>.
        </p>

        <p className={styles.thanksText}>
          Thanks,<br />
          <strong>The SkillGigs Team</strong>
        </p>

        <p className={styles.contactText}>
          If you believe this is an error or need help, reply to this email or reach out to us at{' '}
          <a href="tel:8447545544" className={styles.contactLink}>(844) 754-5544</a> or at{' '}
          <a href="mailto:support@skillgigs.com" className={styles.contactLink}>support@skillgigs.com</a>.
        </p>

        <p className={styles.unsubscribeText}>
          If you would prefer not to receive job invitations or emails from SkillGigs, you can{' '}
          <a href="https://skillgigs.com/unsubscribe" className={styles.unsubscribeLink} target="_blank" rel="noreferrer">
            unsubscribe here
          </a>.
        </p>
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.footerLogo}>
          <SkillGigs className={styles.footerLogoSvg} />
        </div>

        <div className={styles.socialIcons}>
          <a href="https://www.linkedin.com/company/skillgigs" target="_blank" rel="noreferrer" className={styles.socialIcon}>
            <FaLinkedinIn />
          </a>
          <a href="https://www.instagram.com/skillgigs" target="_blank" rel="noreferrer" className={styles.socialIcon}>
            <FaInstagram />
          </a>
          <a href="https://www.facebook.com/skillgigs" target="_blank" rel="noreferrer" className={styles.socialIcon}>
            <FaFacebookF />
          </a>
          <a href="https://www.youtube.com/@skillgigs" target="_blank" rel="noreferrer" className={styles.socialIcon}>
            <FaYoutube />
          </a>
        </div>

        <div className={styles.footerAddress}>
          5177 Richmond Ave, Ste 600 Houston, TX 77056
        </div>

        <div className={styles.footerBadges}>
          <div className={styles.badgeRow}>
            <a href="https://apps.apple.com/app/skillgigs/id1476711597" target="_blank" rel="noreferrer" className={styles.appBadge}>
              <AppStoreBadge />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.skillgigs" target="_blank" rel="noreferrer" className={styles.appBadge}>
              <GooglePlayBadge />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderEmailPreviewTemplate;
